<!-- <p>energy-reporting works!</p> -->
<div class="main-div" *ngIf="!useNewLayout">
    <div class="title-container">
        <div class="title alignRow">
            <span style="font-weight: bold;">Utility Reporting</span>
            <span class="toolbar-spacer"></span>
            <button mat-raised-button class="time-button" style="margin-right: 1em;" [matMenuTriggerFor]="timeMenu">
                <mat-icon>access_time</mat-icon>
                <span>Change Time Period</span>
            </button>
            <mat-icon style="cursor: pointer;" *ngIf="selectedLocation"
                (click)="selectLocation($event, true)">close</mat-icon>
            <div class="location-dropdown">
                <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='MainLocations' placeholder="Select Location"
                    [fields]="locationFields" [allowFiltering]="true" filterType="contains"
                    (change)="selectLocation($event)">
                    <ng-template #itemTemplate let-data>
                        <div>
                            <span>{{ data.Name }}</span>
                        </div>
                    </ng-template>
                </ejs-dropdownlist>
            </div>
        </div>
        <div class="title alignRow">
            <span *ngIf="strDuration != 'custom'" style="font-style: italic;">
                Data for Last
                {{getPeriodLength(numDays)}} </span>
            <span style="font-style: italic;">
                &nbsp;in {{selectedLocation ? selectedLocation.Name : "All Locations"}}
            </span>
            <span class="toolbar-spacer"></span>
            <span *ngIf="startDate && endDate"
                style="margin-left: 1em; font-style: italic;">({{convertEpoch(startDate.getTime())}} -
                {{convertEpoch(endDate.getTime())}})</span>
        </div>
    </div>
    <hr>
    <div class="total-div" *ngIf="organisation">
        <span style="grid-column: 1 / -1; font-size: large;">{{organisation.Name}} Utility Data</span>
        <span>Latest Value</span>
        <span>Period Average</span>
        <span>Period Running Average</span>
        <span>Difference</span>
        <span>Total</span>
        <span>{{recentRunningValue}}{{targetSI}}</span>
        <span>{{totalAvgPeriod}}{{targetSI}}</span>
        <span>{{totalAvgRunning}}{{targetSI}}</span>
        <span>{{totalDifference}}{{targetSI}}</span>
        <span>{{totalMax}}{{targetSI}}</span>
    </div>
    <hr>
    <div class="listview-div" *ngIf="datapointAssets.length > 0">
        <div class="title-buttons">
            <span></span>
            <span>Per DataPoint Utility Data</span>
            <div class="dp-buttons">
                <button mat-raised-button (click)="excludeIncludeDatapoints(false)">Exclude All</button>
                <button mat-raised-button (click)="excludeIncludeDatapoints(true)">Include All</button>
            </div>
        </div>
        <div class="datapoint-item">
            <span>DataPoint</span>
            <span>Min</span>
            <span>Max</span>
            <span>Runtime</span>
            <span>Average</span>
            <span>Running Average</span>
            <span>Usage</span>
        </div>
        <div class="listview-container">
            <ejs-listview #listviewInstance [dataSource]='filteredDatapointAssets' cssClass='e-list-template'>
                <ng-template #template let-data>
                    <div class="ejs-listview-item datapoint-item alignRow" *ngIf="data.Datapoint">
                        <span>{{data.Datapoint.DPTitle}}</span>
                        <span>{{ getDatapointEnergyMetrics(data.Datapoint.DataPointID).Min
                            }}{{data.Datapoint.SI}}</span>
                        <span>{{ getDatapointEnergyMetrics(data.Datapoint.DataPointID).Max
                            }}{{data.Datapoint.SI}}</span>
                        <span>{{ getRuntimeString(getDatapointEnergyMetrics(data.Datapoint.DataPointID).RunTime)
                            }}</span>
                        <span>{{ getDatapointEnergyMetrics(data.Datapoint.DataPointID).Avg
                            }}{{data.Datapoint.SI}}</span>
                        <span>{{ getDatapointEnergyMetrics(data.Datapoint.DataPointID).RunningAvg
                            }}{{data.Datapoint.SI}}</span>
                        <span>{{ getDatapointEnergyMetrics(data.Datapoint.DataPointID).Diff
                            }}{{data.Datapoint.SI}}</span>
                        <mat-checkbox color="primary" [checked]="checkDatapointIncluded(data.Datapoint)"
                            (change)="toggleDatapointInclusion($event, data)"></mat-checkbox>
                    </div>
                </ng-template>
            </ejs-listview>
        </div>
    </div>
    <div class="buttons alignRow">
        <span class="toolbar-spacer"></span>
        <ejs-dropdownlist id="dropdown" #dropdownReport [dataSource]='exportTypes' [fields]="exportFields"
            [(value)]="selectedExportType">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.text }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
        <ejs-dropdownlist id="dropdown2" #dropdownDetail [dataSource]='detailTypes' [fields]="detailFields"
            [(value)]="selectedDetailOption" style="margin-left: 1em;">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.text }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
        <button mat-raised-button [disabled]="includedDatapointAssets.length == 0" style="margin-left: 1em;"
            (click)="generateReport()">
            <span>Generate Report for {{includedDatapointAssets.length}} {{includedDatapointAssets.length != 1 ?
                "DataPoints" : "DataPoint"}}</span>
            <mat-icon>description</mat-icon>
        </button>
        <span class="toolbar-spacer"></span>
    </div>
</div>

<div class="main-div-2" *ngIf="useNewLayout">
    <div class="data-model-div">
        <div class="box-title">Data Model</div>
        <app-organisation-data-model [onReportingPage]="true" [outputDataModel]="true"
            (dataModel)="setDataModel($event)" (dragComplete)="respondToDrag($event)"></app-organisation-data-model>
    </div>
    <div class="report-configuration-div">
        <div class="configure-report-title alignRow">
            <!-- <mat-icon matTooltip="Report History">history</mat-icon> -->
            <span class="toolbar-spacer"></span>
            <span>Configure Summary Reports</span>
            <span class="toolbar-spacer"></span>
            <mat-icon matTooltip="Create Summary Report" (click)="openReportConfiguration()">add</mat-icon>
        </div>
        <div class="report-item report-header">
            <span>Name</span>
            <span>Interval</span>
            <span>File Type</span>
        </div>
        <div class="listview-3">
            <ejs-listview #listviewInstance_3 [dataSource]='summaryReports' [fields]="reportFields"
                cssClass='e-list-template'>
                <ng-template #template let-data>
                    <div class="ejs-listview-item report-item alignRow">
                        <span>{{data.Name}}</span>
                        <span>{{data.IntervalName}}</span>
                        <span>{{data.FileTypeName}}</span>
                        <mat-icon (click)="editSummaryReport(data)">edit</mat-icon>
                        <span class="app-icon app-icon--delete"><mat-icon
                                (click)="requestDeleteSummaryReport(data)" /></span>
                    </div>
                </ng-template>
            </ejs-listview>
        </div>
        <div class="report-history-button alignColumn">
            <button mat-raised-button (click)="goToReportHistory()">
                <span>Report History</span>
                <mat-icon>history</mat-icon>
            </button>
        </div>
    </div>
    <div class="report-div">
        <div class="box-title">Instant Report</div>
        <div class="report-options alignRow">
            <button mat-raised-button class="time-button" style="margin: auto;" [matMenuTriggerFor]="timeMenu">
                <mat-icon>access_time</mat-icon>
                <span>Change Time Period</span>
            </button>
            <span *ngIf="startDate && endDate"
                style="margin-left: 1em; font-style: italic;">({{convertEpoch(startDate.getTime())}} -
                {{convertEpoch(endDate.getTime())}})</span>
        </div>
        <div class="listview-2 drag-target">
            <ejs-listview #listviewInstance [dataSource]='includedNodes' [fields]="dataModelNodeFields"
                cssClass='e-list-template'>
                <ng-template #template let-data>
                    <div class="ejs-listview-item node-item alignRow">
                        <mat-icon style="margin-right: 5px;">
                            {{data.NodeType == "folder" ? "folder"
                            : data.NodeType == "sensor" ? "sensors"
                            : data.NodeType == "datapoint" ? "show_chart"
                            : data.NodeType == "organisation" ? "factory"
                            : "question_mark"}}
                        </mat-icon>
                        <span>{{data.Name}}</span>
                        <span>{{getNodeChildrenText(data)}}</span>
                        <button mat-icon-button (click)="removeReportItemNode(data)"><mat-icon>close</mat-icon></button>
                    </div>
                </ng-template>
            </ejs-listview>
            <div class="drag-message" *ngIf="includedNodes.length == 0">Drag a node from the Data Model here to add it
                to the report.</div>
        </div>
        <div class="report-options alignRow" style="grid-template-columns: 1fr 1fr 1fr;">
            <ejs-dropdownlist id="dropdown" #dropdownReport [dataSource]='exportTypes' [fields]="exportFields"
                [(value)]="selectedExportType">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.text }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
            <ejs-dropdownlist id="dropdown2" #dropdownDetail [dataSource]='detailTypes' [fields]="detailFields"
                [(value)]="selectedDetailOption" style="margin-left: 1em;">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.text }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
            <div>
                <button mat-raised-button [disabled]="reportDatapointEnergyMetrics.length == 0 || waiting"
                    (click)="generateReport()" style="margin: auto;">
                    <span>Generate Report for {{reportDatapointEnergyMetrics.length}}
                        {{reportDatapointEnergyMetrics.length
                        != 1 ?
                        "DataPoints" : "DataPoint"}}</span>
                    <mat-icon>description</mat-icon>
                </button>
                <span *ngIf="waiting">waiting</span>
            </div>
        </div>
    </div>
</div>

<mat-menu #timeMenu="matMenu">
    <div style="margin: 1em;">
        <span>Date Range:</span>
        \
        <br><br>
        <span>Duration:</span>
        <app-duration-selector [(duration)]="strDuration"
            (durationChange)="selectNumDays($event)"></app-duration-selector>
    </div>
</mat-menu>

<div style="position: absolute; top: calc(50% - 125px); left: calc(50% - 375px); z-index: -999;">
    <ejs-chart #sumDeltaChart id="sum-delta-chart" [zoomSettings]="zoomSettings" [legendSettings]='legend'
        [enableCanvas]="true" [tooltip]='tooltipSettings' [primaryXAxis]="sensorXAxis" [crosshair]='crosshair'
        background="#FFFFFF" [border]="borderSettings" [palettes]='palette' [height]="'250px'" [width]="'750px'">
    </ejs-chart>
</div>
<div style="position: absolute; top: calc(50% - 125px); left: calc(50% - 375px); z-index: -999;">
    <ejs-chart #sumTotalChart id="sum-total-chart" [zoomSettings]="zoomSettings" [legendSettings]='legend'
        [enableCanvas]="true" [tooltip]='tooltipSettings' [primaryXAxis]="sensorXAxis" [crosshair]='crosshair'
        background="#FFFFFF" [border]="borderSettings" [palettes]='palette' [height]="'250px'" [width]="'750px'">
    </ejs-chart>
</div>
<div style="position: absolute; top: -999999px; left: -999px; z-index: -999;">
    <ng-container *ngFor="let dp of datapointRelevantData">
        <ejs-chart id="chart_{{dp.DatapointID}}" [zoomSettings]="zoomSettings" [title]="dp.DPTitle"
            [legendSettings]='legend' [enableCanvas]="true" [tooltip]='tooltipSettings' [primaryXAxis]="sensorXAxis"
            [crosshair]='crosshair' background="#FFFFFF" [border]="borderSettings" [palettes]='palette'
            [height]="'650px'" [width]="'1500px'">
        </ejs-chart>
    </ng-container>
</div>
<div style="position: absolute; top: -999999px; left: -999px; z-index: -999;">
    <ng-container *ngFor="let item of pieChartData">
        <ejs-accumulationchart *ngIf="item.length > 0" id="pie_{{item[0].nodeUID}}" [title]="item[0].title"
            [legendSettings]="pieChartLegendSettings" [height]="'650px'" [width]="'1500px'" [enableAnimation]="false"
            [enableBorderOnMouseMove]="false">
            <e-accumulation-series-collection>
                <e-accumulation-series name='Datapoint' [dataSource]='item' xName='name' yName='usage'
                    [animation]="{enable: false}" [dataLabel]="pieChartLabels">
                </e-accumulation-series>
            </e-accumulation-series-collection>
        </ejs-accumulationchart>
    </ng-container>
</div>